<template>
  <div>
    <!-- 选项框 -->
    <div class="home screenbox p5">
      <div id="searchBar" :class="searchBarFixed == true ? 'searchBar' : ''" class="screen clearfix">
        <div class="w10 fr">
          <div class="wrap">
            <el-select v-model="yearsvalue" @change="yearsInput" filterable size="medium">
              <el-option v-for="item in years" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="icons fl">
          <ul class="clearfix">
            <li>
              <a @click="icon1" class="icon1 w7-09" title="总体">
                <span>总体</span>
              </a>
            </li>
            <li>
              <a @click="icon2" class="icon2 w9" title="开办企业">
                <span>开办企业</span>
              </a>
            </li>
            <li>
              <a @click="icon3" class="icon3 w11-09" title="办理施工许可证">
                <span>办理施工许可证</span>
              </a>
            </li>
            <li>
              <a @click="icon4" class="icon4 w9" title="获得电力">
                <span>获得电力</span>
              </a>
            </li>
            <li>
              <a @click="icon5" class="icon5 w9" title="登记财产">
                <span>登记财产</span>
              </a>
            </li>
            <li>
              <a @click="icon6" class="icon6 w9" title="获得信贷">
                <span>获得信贷</span>
              </a>
            </li>
            <li>
              <a @click="icon7" class="icon7 w11-09" title="保护少数投资者">
                <span>保护少数投资者</span>
              </a>
            </li>
            <li>
              <a @click="icon8" class="icon8 w7-09" title="纳税">
                <span>纳税</span>
              </a>
            </li>
            <li>
              <a @click="icon9" class="icon9 w9" title="跨境贸易">
                <span>跨境贸易</span>
              </a>
            </li>
            <li>
              <a @click="icon10" class="icon10 w9" title="执行合同">
                <span>执行合同</span>
              </a>
            </li>
            <li>
              <a @click="icon11" class="icon11 w9" title="办理破产">
                <span>办理破产</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 地图 -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <div :style="{ height: '592px', width: '100%' }" ref="myEchart" id="myEchart"></div>
      </div>
    </div>

    <!-- 图表 -->
    <div class="home p5 clearfix">
      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1>{{ barindicatorname }}得分前十的经济体（城市）</h1>
          </div>
          <div class="full_box">
            <el-button class="replay" round @click="chart1replay">replay</el-button>
          </div>
          <div ref="chart1div" id="chart1div" style="width:100%">
            <div v-show="chart1_chart" :style="{ height: '400px', width: '100%' }" ref="chart1" id="chart1"></div>
            <img v-show="chart1_img" src="../../assets/imgs/cgitchartdefault.jpg"
              style="margin:0 auto; height:400px;width: 100%;" />
          </div>
        </div>
      </div>
      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1>{{ selectyear }}年{{ barindicatorname }}排名后十位经济体（城市）</h1>
          </div>
          <div v-show="chart2_chart" :style="{ height: '400px', width: '100%' }" ref="chart2" id="chart2"></div>
          <img v-show="chart2_img" src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:400px;width: 100%;" />
        </div>
      </div>
    </div>
    <div class="home p5 clearfix">
      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1>{{ selectyear }}年{{ barindicatorname }}得分上升幅度前十的经济体（城市）</h1>
          </div>
          <div v-show="chart3_chart" :style="{ height: '400px', width: '95%' }" ref="chart3" id="chart3"></div>
          <img v-show="chart3_img" src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:400px;width: 100%;" />
        </div>
      </div>

      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1>{{ selectyear }}年{{ barindicatorname }}得分下降幅度前十的经济体（城市）</h1>
          </div>
          <div v-show="chart4_chart" :style="{ height: '400px', width: '95%' }" ref="chart4" id="chart4"></div>
          <img v-show="chart4_img" src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:400px;width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
// import "../../../node_modules/echarts/map/js/world.js";
import cChart from "./cgit_chart.vue";
import { initCharts } from "../../assets/js/world_dbusiness.js";
import { barscroll } from "../../assets/js/barscroll.js";
import { api } from "@/require/api";

export default {
  data() {
    return {
      searchBarFixed: false, //下拉搜索框
      years: [], ///下拉值
      yearsvalue: "",
      selectyear: "", //下拉所有区域value
      indicatorid: 1, //指标id
      indicatorname: "总体", //指标名称
      min: 0,
      max: 100,
      worldData: [], //世界地图
      barindicatorname: "", //图1-4的标题：指标名称
      tData: [],
      bardata1: [], //图1
      bardata2: [], //图2
      bardata3: [], //图3
      bardata4: [], //图4
      nameMap: {},
      chart1_chart: true,
      chart1_img: false,
      chart2_chart: true,
      chart2_img: false,
      chart3_chart: true,
      chart3_img: false,
      chart4_chart: true,
      chart4_img: false,
      //data:
      //  [{ name: "新西兰", data: { value: [{ bar: 1, calcValue: '87.11', orderValue: '4789798' }, { bar: 2, calcValue: '87.11', orderValue: '4789798' }, { bar: 3, calcValue: '87.11', orderValue: '4789798' }, { bar: 4, calcValue: '87.11', orderValue: '4789798' }] } }, { name: "波兰", data: { value: [{ bar: 1, calcValue: '87.11', orderValue: '4789798' }, { bar: 2, calcValue: '87.11', orderValue: '4789798' }, { bar: 3, calcValue: '87.11', orderValue: '4789798' }, { bar: 4, calcValue: '87.11', orderValue: '4789798' }] } }]
    };
  },
  created() {
    this.loadnameMapdata();
    this.loadselectdata();
  },
  mounted() {
    // this.icon1(); //给第一个指标赋样式并加载数据
    this.loadselectdata().then(() => {
      this.icon1(); //给第一个指标赋样式并加载数据
    })
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    //加载年度下拉
    async loadselectdata() {
      const { code, data } = await api.get(
        "/doingBusinessController/getTimesAndCountrys",
        {}
      );
      if (code === 0) {
        this.years = data.times; //下拉值
        this.yearsvalue = data.times[0].name + "";
        this.selectyear = data.times[0].name + "";
      }
    },
    //年度选择后
    yearsInput(value) {
      this.selectyear = value;
      this.getmapWorld();
      this.loadbar2(); //图2
      this.loadbar3(); //图3
      this.loadbar4(); //图4
    },
    //年度初始当前年
    // setyear() {
    //   if (this.selectyear == "") {
    //     this.selectyear = new Date().getFullYear();
    //   }
    // },
    // 分布图的汉英对应
    async loadnameMapdata() {
      const { code, data } = await api.get(
        "/HomePageController/getCountryMap",
        {}
      );
      if (code === 0) {
        this.nameMap = data;
      }
    },
    //分布图
    async getmapWorld() {
      // this.setyear();
      const { code, data } = await api.get(
        "/doingBusinessController/getHomePageMapInfo",
        {
          indicatorName: this.indicatorname,
          timeName: this.selectyear,
          stateIds: -1
        }
      );
      if (code === 0) {
        if (data.length > 0) {
          this.min = data[0].min;
          this.max = data[0].max;
          this.worldData = data[0].data;
        } else {
          this.min = 0;
          this.max = 0;
          this.worldData = [];
        }
      }

      let chartmap = this.$echarts.init(document.getElementById("myEchart"));
      //随屏幕大小缩放
      window.onresize = () => {
        chartmap.resize();
      };

      this.chart = echarts.init(this.$refs.myEchart);
      initCharts(this.chart, this.worldData, this.nameMap, this.min, this.max); //world_dbusiness.js
    },
    //图1 replay
    chart1replay() {
      this.loadbar1();
    },
    //图1
    async loadbar1() {
      // this.setyear();

      const { code, data } = await api.get(
        "/doingBusinessController/getAllTopScore",
        {
          indicatorId: this.indicatorid
        }
      );
      if (code === 0) {
        if (data[0].IndicatorName == "营商便利度")
          this.barindicatorname = data[0].IndicatorName + "总";
        else this.barindicatorname = '"' + data[0].IndicatorName + '"';
        this.bardata1 = data.reverse();

        this.chart = echarts.init(this.$refs.chart1);

        var tData1 = [];
        if (this.bardata1 != undefined) {
          tData1 = this.makedata_bar1(tData1, this.bardata1);
        }

        barscroll(this.chart, tData1, 1, true, false, false, $("#chart1div"));
      }
    },
    //图2
    async loadbar2() {
      // this.setyear();

      const { code, data } = await api.get(
        "/doingBusinessController/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear,
          dataTypeFlag: true
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart2_chart = true;
          this.chart2_img = false;
          this.bardata2 = data;
          this.chart = echarts.init(this.$refs.chart2);

          var tData2 = [];
          if (this.bardata2 != undefined) {
            tData2 = this.makedata(tData2, this.bardata2);
          }
          barscroll(this.chart, tData2, 2, false, false);
        } else {
          this.chart2_chart = false;
          this.chart2_img = true;
        }
      }
    },
    //图3
    async loadbar3() {
      // this.setyear();
      const { code, data } = await api.get(
        "/doingBusinessController/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear,
          flagNum: 0,
          dataTypeFlag: false
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart3_chart = true;
          this.chart3_img = false;
          this.bardata3 = data;
          this.chart = echarts.init(this.$refs.chart3);

          var tData3 = [];
          if (this.bardata3 != undefined) {
            tData3 = this.makedata(tData3, this.bardata3);
          }
          barscroll(this.chart, tData3, 3, false, true, false);
        } else {
          this.chart3_chart = false;
          this.chart3_img = true;
        }
      }
    },
    //图4
    async loadbar4() {
      // this.setyear();
      const { code, data } = await api.get(
        "/doingBusinessController/getTwentyInfo",
        {
          indicatorId: this.indicatorid,
          timeid: this.selectyear,
          flagNum: 1,
          dataTypeFlag: false
        }
      );
      if (code === 0) {
        if (data.data.length > 0) {
          this.chart4_chart = true;
          this.chart4_img = false;
          this.bardata4 = data;
          this.chart = echarts.init(this.$refs.chart4);

          var tData4 = [];
          if (this.bardata4 != undefined) {
            tData4 = this.makedata(tData4, this.bardata4);
          }
          // console.log(tData4,'tData4')
          barscroll(this.chart, tData4, 4, false, true, true);
        } else {
          this.chart4_chart = false;
          this.chart4_img = true;
        }
      }
    },
    //重新构造echart需要的数据格式
    makedata_bar1(tdata, bardata) {
      for (let i = 0; i < bardata.length; i++) {
        tdata.push({
          category: bardata[i].category,
          data: []
        });
        for (let j = 0; j < bardata[i].data.length; j++) {
          tdata[i].data.push({
            name: bardata[i].data[j].name,
            value: bardata[i].data[j].value
          });
        }
      }
      return tdata;
    },
    makedata(tdata, bardata) {
      tdata.push({
        category: bardata.category,
        data: []
      });
      for (let i = 0; i < bardata.data.length; i++) {
        tdata[0].data.push({
          name: bardata.data[i].name,
          value: bardata.data[i].value
        });
      }
      return tdata;
    },
    //icon赋不同样式
    icon1() {
      this.indicatorid = 1;
      this.indicatorname = "总体";
      $(".icon1").addClass("icon1_on");
      $(".icon1")
        .children()
        .addClass("icon1_on_span");
      this.icon0(1);
    },
    icon2() {
      this.indicatorid = 2;
      this.indicatorname = "开办企业";
      $(".icon2").addClass("icon2_on");
      $(".icon2")
        .children()
        .addClass("icon2_on_span");
      this.icon0(2);
    },
    icon3() {
      this.indicatorid = 3;
      this.indicatorname = "办理施工许可证";
      $(".icon3").addClass("icon3_on");
      $(".icon3")
        .children()
        .addClass("icon3_on_span");
      this.icon0(3);
    },
    icon4() {
      this.indicatorid = 4;
      this.indicatorname = "获得电力";
      $(".icon4").addClass("icon4_on");
      $(".icon4")
        .children()
        .addClass("icon4_on_span");
      this.icon0(4);
    },
    icon5() {
      this.indicatorid = 5;
      this.indicatorname = "登记财产";
      $(".icon5").addClass("icon5_on");
      $(".icon5")
        .children()
        .addClass("icon5_on_span");
      this.icon0(5);
    },
    icon6() {
      this.indicatorid = 6;
      this.indicatorname = "获得信贷";
      $(".icon6").addClass("icon6_on");
      $(".icon6")
        .children()
        .addClass("icon6_on_span");
      this.icon0(6);
    },
    icon7() {
      this.indicatorid = 7;
      this.indicatorname = "保护少数投资者";
      $(".icon7").addClass("icon7_on");
      $(".icon7")
        .children()
        .addClass("icon7_on_span");
      this.icon0(7);
    },
    icon8() {
      this.indicatorid = 8;
      this.indicatorname = "纳税";
      $(".icon8").addClass("icon8_on");
      $(".icon8")
        .children()
        .addClass("icon8_on_span");
      this.icon0(8);
    },
    icon9() {
      this.indicatorid = 9;
      this.indicatorname = "跨境贸易";
      $(".icon9").addClass("icon9_on");
      $(".icon9")
        .children()
        .addClass("icon9_on_span");
      this.icon0(9);
    },
    icon10() {
      this.indicatorid = 10;
      this.indicatorname = "执行合同";
      $(".icon10").addClass("icon10_on");
      $(".icon10")
        .children()
        .addClass("icon10_on_span");
      this.icon0(10);
    },
    icon11() {
      this.indicatorid = 11;
      this.indicatorname = "办理破产";
      $(".icon11").addClass("icon11_on");
      $(".icon11")
        .children()
        .addClass("icon11_on_span");
      this.icon0(11);
    },
    //除当时icon，移除其它on样式
    icon0(num) {
      for (let i = 1; i <= 11; i++) {
        if (num != i) {
          $(".icon" + i).removeClass("icon" + i + "_on");
          $(".icon" + i)
            .children()
            .removeClass("icon" + i + "_on_span");
        }
      }
      this.getmapWorld();
      this.loadbar1(); //图1
      this.loadbar2(); //图2
      this.loadbar3(); //图3
      this.loadbar4(); //图4
    },
    // 11个指标固定
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if ($("#searchBar") != null) {
        let offsetTop = document.getElementById("searchBar").offsetTop;
        scrollTop > offsetTop
          ? (this.searchBarFixed = true)
          : (this.searchBarFixed = false);
      }
    }
  },
  components: {
    cChart
  },
  watch: {
    $route: function () { }
  }
};
</script>

<style lang='less' scoped>
// 下拉搜索固定
.searchBar {
  position: fixed;
  background-color: #edf4f8;
  top: 0;
  width: 99.6%;
  padding-right: 2px !important;
  z-index: 999999;
}

// 选择框
.screenbox {
  height: 50px;
  box-sizing: border-box;

  .screen {
    box-sizing: border-box;
    padding: 5px 0 5px 5px;

    .w10 {
      width: 10%;
      padding: 0 5px;
      position: relative;

      .wrap {
        height: 34px;
        border: 0;
        position: relative;
      }
    }

    .icons {
      width: 90%;
      position: relative;
      background: #fff;
      border: 1px solid #d7dfe3;
      height: 34px;
      line-height: 34px;

      ul {
        width: 100%;

        li {

          //   height: 34px;
          a {
            float: left;
            display: block;
            color: #394248;
            border-right: 1px solid #d7dfe3;
            font-size: 15px;
            height: 34px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 10px;
          }

          .icon {
            height: 34px;
            padding-left: 40px;
            // padding: 0 5px;
            position: relative;
            text-align: center;
          }

          .w9 {
            width: 9.09%;
          }

          .w11-09 {
            width: 10.89%;
          }

          .w7-09 {
            width: 7.29%;
          }
        }
      }
    }
  }
}

// 地图
.mapbox {
  padding: 5px 10px;
  box-sizing: border-box;
}

.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}

.card_title {
  background: url(../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
}

.card_title h1 {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 15px;
}

.full_box {
  position: absolute;
  right: 20px;
  top: 10px;
}

.fl11 {
  height: 34px;
  line-height: 34px;
}

.fl11 ul {
  width: 100%;
}

.fl11 ul li a {
  float: left;
  display: block;
  color: #394248;
  border-right: 1px solid #d7dfe3;
  font-size: 15px;
  height: 34px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 10px;
}

.icon1 {
  background: url(../../assets/imgs/icon1_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon1:hover {
  background: url(../../assets/imgs/icon1_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
  color: #f6231b;
}

.icon1_on {
  background: url(../../assets/imgs/icon1_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon1:hover span {
  color: #f6231b;
  font-weight: 700;
}

.icon1_on_span {
  color: #f6231b;
  font-weight: 700;
}

.icon2 {
  background: url(../../assets/imgs/icon2_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon2:hover {
  background: url(../../assets/imgs/icon2_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon2_on {
  background: url(../../assets/imgs/icon2_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon2:hover span {
  color: #3bd5a1;
  font-weight: 700;
}

.icon2_on_span {
  color: #3bd5a1;
  font-weight: 700;
}

.icon3 {
  background: url(../../assets/imgs/icon3_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon3:hover {
  background: url(../../assets/imgs/icon3_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon3_on {
  background: url(../../assets/imgs/icon3_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon3:hover span {
  color: #9954ac;
  font-weight: 700;
}

.icon3_on_span {
  color: #9954ac;
  font-weight: 700;
}

.icon4 {
  background: url(../../assets/imgs/icon4_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon4:hover {
  background: url(../../assets/imgs/icon4_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon4_on {
  background: url(../../assets/imgs/icon4_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon4:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon4_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon5 {
  background: url(../../assets/imgs/icon5_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon5:hover {
  background: url(../../assets/imgs/icon5_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon5_on {
  background: url(../../assets/imgs/icon5_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon5:hover span {
  color: #fd924b;
  font-weight: 700;
}

.icon5_on_span {
  color: #fd924b;
  font-weight: 700;
}

.icon6 {
  background: url(../../assets/imgs/icon6_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon6:hover {
  background: url(../../assets/imgs/icon6_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon6_on {
  background: url(../../assets/imgs/icon6_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon6:hover span {
  color: #6a75f5;
  font-weight: 700;
}

.icon6_on_span {
  color: #6a75f5;
  font-weight: 700;
}

.icon7 {
  background: url(../../assets/imgs/icon7_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon7:hover {
  background: url(../../assets/imgs/icon7_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon7_on {
  background: url(../../assets/imgs/icon7_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon7:hover span {
  color: #5cd46c;
  font-weight: 700;
}

.icon7_on_span {
  color: #5cd46c;
  font-weight: 700;
}

.icon8 {
  background: url(../../assets/imgs/icon8_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon8:hover {
  background: url(../../assets/imgs/icon8_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon8_on {
  background: url(../../assets/imgs/icon8_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon8:hover span {
  color: #c79706;
  font-weight: 700;
}

.icon8_on_span {
  color: #c79706;
  font-weight: 700;
}

.icon9 {
  background: url(../../assets/imgs/icon9_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon9:hover {
  background: url(../../assets/imgs/icon9_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon9_on {
  background: url(../../assets/imgs/icon9_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon9:hover span {
  color: #71b5fe;
  font-weight: 700;
}

.icon9_on_span {
  color: #71b5fe;
  font-weight: 700;
}

.icon10 {
  background: url(../../assets/imgs/icon10_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon10:hover {
  background: url(../../assets/imgs/icon10_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon10_on {
  background: url(../../assets/imgs/icon10_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon10:hover span {
  color: #fd91a3;
  font-weight: 700;
}

.icon10_on_span {
  color: #fd91a3;
  font-weight: 700;
}

.icon11 {
  background: url(../../assets/imgs/icon11_ys.png) no-repeat 15px 7px;
  height: 24px;
  padding-left: 40px;
}

.icon11:hover {
  background: url(../../assets/imgs/icon11_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon11_on {
  background: url(../../assets/imgs/icon11_h.png) no-repeat 15px 7px;
  height: 34px;
  padding-left: 40px;
  cursor: pointer;
}

.icon11:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon11_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

.fl11 ul li a:nth-child(11) {
  border-right: none;
}

.replay {
  background: #f4f8fb;
  border: 1px solid #d4d9dc;
  border-radius: 100px;
  padding: 5px 15px;
  color: #232e36;
  font-size: 14px;
}

.w9 {
  width: 9.09%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

.w11-09 {
  width: 10.89%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

.w7-09 {
  width: 7.29%;
  padding: 0 5px;
  position: relative;
  padding-left: 40px;
}

/*营商数据库二级页面*/
.year {
  padding: 25px;
}

.year img {
  float: left;
}

.year h2 {
  float: left;
  font-size: 18x;
  line-height: 25px;
  padding-left: 10px;
}

.col-lg-6 {
  float: left;
  border-left: 1px solid #d7dfe3;
  border-top: 1px solid #d7dfe3;
  padding: 20px 20px 30px 20px;
}

.review {
  border: 1px solid transparent;
  border-radius: 5px;
  color: #777;
  display: flex;
  font-size: 12px;
  align-items: center;
  margin: 0px 10px;
  width: 57.5%;
  margin-top: 9px;
}

.progress {
  background-color: rgba(100, 100, 100, 0.2);
  border-radius: 100px;
  position: relative;
  margin: 0 5px;
  height: 20px;
  width: 90%;
}

.progress-done1 {
  background: linear-gradient(to left, rgb(103, 194, 58), rgb(166, 213, 83));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.progress-done2 {
  background: linear-gradient(to left, rgb(242, 97, 90), rgb(255, 148, 114));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.percent {
  color: #333;
  white-space: nowrap;
}

.characteristics ul li {
  float: left;
  padding-left: 5px;
  padding-right: 20px;
  padding-top: 10px;
}

.characteristics ul li span {
  font-weight: bold;
}

.col-lg-6 h2 {
  font-size: 15px;
  font-weight: bold;
  /*! line-height: 34px; */
  margin-top: 9px;
  margin-left: 20px;
}

.icon-container {
  /*! position: relative; */
  /*! top: 25px; */
  /*! left: 10px; */
}

.percent1 {
  position: absolute;
  left: 0px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

.menu_box {
  width: 30%;
}

.menu_box_ul {
  background: #f4f7fa;
  border: 1px solid #d4dfea;
  border-radius: 20px;
  padding: 15px;
  padding-left: 0;
  margin: 15px;
  position: relative;
  z-index: 1000;
}

.menu_box_ul li {
  line-height: 35px;
}

.menu_box_ul li a {
  display: block;
  height: 34px;
  font-size: 13px;
  line-height: 34px;
  color: #30363c;
}

.txbox {
  margin-left: 200px;
  position: absolute;
}

.ysbg ul {
  width: 50%;
  float: left;
  padding: 25px;
}

.ysbg ul li {
  line-height: 35px;
}

.ysbg ul li a {
  color: #333;
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.ysbg ul li span {
  color: #666;
}

.icon_lx {
  padding-right: 5px;
}

.ld_jjt {
  background: #f4f7fa !important;
  border: 1px solid#d4dfea;
  border-radius: 100px;
}

.black {
  color: #30363c !important;
}

.k-icon2 {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../assets/imgs/drop-down2.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}
</style>